
export const environment = 'network'
export const sysVersion='V6.17.38-260420'
//局域网配置
//export const environment = 'local'


